"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Grocery;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Grocery(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "76",
    height: "48",
    viewBox: "0 0 76 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group 841"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector",
    d: "M9.25688 6.24312C9.57962 5.88978 9.8065 5.45916 9.91577 4.99254C10.025 4.52593 10.013 4.03896 9.88088 3.57834C9.77267 2.96159 9.47955 2.39262 9.04068 1.94742C8.60181 1.50223 8.03807 1.202 7.4247 1.08678C6.94964 0.974364 6.45541 0.971123 5.97893 1.07731C5.50245 1.1835 5.05606 1.39635 4.67307 1.7C4.29008 2.00364 3.98037 2.39021 3.76715 2.83083C3.55393 3.27144 3.44269 3.75471 3.44172 4.24454C3.44172 4.24454 3.44172 4.32451 3.44172 4.35115C2.64677 4.55386 1.95802 5.05165 1.51449 5.74405C1.07095 6.43645 0.905671 7.27189 1.05195 8.08183C1.16644 8.71218 1.46472 9.29425 1.90904 9.75439C2.35336 10.2145 2.92374 10.532 3.54795 10.6667C4.34178 10.8337 5.16911 10.7009 5.87136 10.2936C6.12517 10.1579 6.41991 10.121 6.69916 10.1899C6.97842 10.2587 7.22255 10.4285 7.38487 10.6667L13.3992 19.074C13.8567 19.7072 14.2482 20.3858 14.5675 21.0993C16.6918 25.8559 26.2775 45.2954 36.2748 32.9708C46.2721 20.6462 25.919 14.3174 20.8872 12.985C20.1297 12.7847 19.4052 12.4751 18.7364 12.0657L14.9127 9.73397L9.25688 6.24312Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_2",
    d: "M52 40.4001C48.5907 40.8201 45.1566 41.0201 41.7201 40.9984C35.5699 40.9836 29.4298 40.5139 23.3527 39.5936C12.5649 37.9157 8.2337 32.3615 6.49588 28.0041C5.93885 26.5352 5.84881 24.9372 6.2374 23.4178C6.62599 21.8984 7.47524 20.5279 8.67484 19.4844C9.10533 19.1136 9.4671 18.6737 9.74429 18.1836C10.0075 17.7745 10.2931 17.3794 10.5998 17",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_3",
    d: "M65.9621 20C67.9705 21.1904 69.5957 22.9687 70.6341 25.1123C72.2086 28.6855 68.2594 32.1651 67.1624 33.035C66.0335 35.2485 64.2134 36.999 62 38",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_4",
    d: "M16 10.9071C17.8557 9.85442 26.6038 5.12991 36.3726 5.00459C48.9912 4.84168 56.6259 9.0399 61 13",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_5",
    d: "M52 40.4815C47.1365 40.8609 42.3525 41 38.5624 41C25.92 41 2 39.3814 2 33.2234C2 31.5163 3.45772 30.2013 7.04903 29",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_6",
    d: "M70.6115 29C73.5596 30.1042 75 31.3697 75 32.8834C75 35.9355 68.7942 37.8462 61 39",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_7",
    d: "M72 37C71.6262 37.4068 62.8415 47 40.7063 47C18.5711 47 10.2937 38.9422 10 38.601",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_8",
    d: "M10 25C12.6615 21.8155 14.9096 23.3689 15 23.4466",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_9",
    d: "M43 30.9541C50.1057 38.296 51.783 41.3867 54.8868 41.8953C58.9812 42.5864 64.3435 40.1347 60.8963 26.1291C60.1038 22.8558 59.2718 21.1215 59.6944 20C59.6944 20 57.0529 23.1037 56.0491 34.11C55.3024 32.16 54.1521 30.3851 52.6716 28.8987C51.1912 27.4123 49.4131 26.2469 47.4509 25.477",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_10",
    d: "M64 11.9939C64 13.0564 63.5779 14.0754 62.8266 14.8266C62.0754 15.5779 61.0564 16 59.9939 16C59.4684 16 58.9481 15.8963 58.4627 15.6948C57.9774 15.4933 57.5365 15.1981 57.1655 14.8259C56.7945 14.4537 56.5005 14.012 56.3005 13.5261C56.1005 13.0401 55.9984 12.5194 56 11.9939C56 10.9347 56.4208 9.91883 57.1698 9.16982C57.9188 8.42081 58.9347 8.00002 59.9939 8.00002C60.5194 7.99842 61.0401 8.10055 61.5261 8.30055C62.012 8.50054 62.4537 8.79449 62.8259 9.16552C63.1981 9.53656 63.4933 9.97734 63.6948 10.4627C63.8963 10.9481 64 11.4684 64 11.9939",
    fill: "#54C8E8"
  })));
}